import {
  Alert,
  Box,
  Center,
  Divider,
  Flex,
  FormProvider,
  Spinner,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { useSignUpRequestDetail } from './hooks/SignUpRequestDetail';
import { SignUpRequestDetailHeader } from './SignUpRequestDetailHeader';
import FormApprovalButton from './SignUpRequestFormApprovalButton';
import SignUpRequestGeneralCompanyInfo from './SignUpRequestGeneralCompanyInfo';
import SignUpRequestAdministratorDataInfo from './SignUpRequestAdministratorDataInfo';
import SignUpRequestLegalRepresentativeInfo from './SignUpRequestLegalRepresentativeInfo';
import SignUpRequestModal from './SignUpRequestModal';
import { DownloadPermissionDocumentButton } from './SignUpRequestDownloadSignupDocumentButton';

const SignUpRequestDetail = () => {
  const { t } = useTranslation();

  const {
    bdData,
    isLoading,
    isMutateLoading,
    isOpen,
    onOpen,
    onClose,
    onSubmit,
    handleSubmit,
    formMethods,
    fields,
    shouldDisableEdit,
  } = useSignUpRequestDetail();

  const validationMessage = fields.map((rep) => rep?.validationMessage);

  if (isLoading || !bdData)
    return (
      <Center pt={8}>
        <Spinner />
      </Center>
    );

  return (
    <Box>
      <SignUpRequestDetailHeader
        title={bdData.companyName}
        badgeText={t(`validationStatus.${bdData.status}`)}
        subtitle={t('signUpRequest.pageSubtitle')}
        rightButton={
          <Flex gap={4} mt={8}>
            <DownloadPermissionDocumentButton signupRequestUuid={bdData.uuid} />
            <FormApprovalButton
              status={bdData.status}
              disabled={shouldDisableEdit}
              onClick={onOpen}
              isLoading={isMutateLoading}
            />
          </Flex>
        }
      />
      <Box maxW="900px">
        {validationMessage.map(
          (message) =>
            message && (
              <Box mb={6}>
                <Alert
                  title={t('explorer.changeRequest.alert.title')}
                  description={message}
                  variant={'error'}
                  showCloseButton={true}
                />
              </Box>
            ),
        )}
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(onOpen)} id="form">
            <SignUpRequestGeneralCompanyInfo {...bdData} />
            <SignUpRequestAdministratorDataInfo {...bdData} />
            <SignUpRequestLegalRepresentativeInfo
              formMethods={formMethods}
              fields={fields}
            />
          </form>
        </FormProvider>
      </Box>

      <Box my={8}>
        <Divider />
      </Box>
      <FormApprovalButton
        status={bdData.status}
        disabled={shouldDisableEdit}
        onClick={handleSubmit(onOpen)}
        isLoading={isMutateLoading}
      />
      <SignUpRequestModal
        isOpen={isOpen}
        onClose={onClose}
        isPending={isMutateLoading}
        onClickConfirm={handleSubmit(onSubmit)}
      />
    </Box>
  );
};

export default SignUpRequestDetail;
